<template>
  <v-card class="mb-4">
      <v-img
        height="400px"
        :src="post.imageURL"
      >
      </v-img>
      <div class="content-card">
        <v-card-title class=" mb-4">
          <div class="content-title">
            <p class="m-0">{{post.title}}</p>
            <span class="caption">{{post.date | momentDate}}</span>
          </div>
        </v-card-title>
        <v-card-text>
          <p>{{post.description}}</p>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn large class="readMore" :to="{name: 'blog', params: { id: post._id }}" target="_blank" >Leer Más</v-btn>
        </v-card-actions>
      </div>
  </v-card>
</template>

<script>
const moment = require('moment');
  export default {
    name:'post',
    props:['post'],
    filters:{
      momentDate: function (value) {
        moment.locale('es');
        return moment(value).fromNow()
      }
    }
  }
</script>

<style lang="scss" scoped>
.content-card{
  padding:2rem;
}
.readMore{
border:1px solid #2F1640;
color:#2F1640;
}
.content-title{
  display: flex;
  width:100%;
  justify-content: space-between;
  & p {
    margin: 0;
    width: 85%;
    @media screen and (max-width:600px){
    width: 65%;
    font-size: 18px;
    font-weight: 600;
    }
  }
  & span{
    line-height: 32px;
    @media screen and (max-width:600px){
      width: 35%;
      text-align: end;
    }
  }

}
</style>